export default "__VITE_ASSET__BEFsixaq__"